import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Policies & Legal routes. Mounted under PublicContentLayout — no app shell, no
// auth — because the sign-in footer and the sign-up form link here, before the
// reader has a session. The documents are identical for every seller, so there
// is nothing to protect.
// - LEGAL          : every policy in one list
// - LEGAL_DOCUMENT : one policy, addressed by slug
export const legalRoutes: RouteRecordRaw[] = [
  {
    path: routes.LEGAL,
    name: 'LEGAL',
    component: () => import('./LegalIndexPage.vue'),
    meta: { title: 'Policies & Legal' },
  },
  {
    path: routes.LEGAL_DOCUMENT,
    name: 'LEGAL_DOCUMENT',
    component: () => import('./LegalDocumentPage.vue'),
    meta: { title: 'Policies & Legal' },
  },
]
